import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { DISH_TYPE_NODE_FRAGMENT } from '../fragments'

const DISH_TYPES_QUERY = gql`
  query dishTypes {
    dishTypes {
      results {
        ...DishTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${DISH_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DISH_TYPES_QUERY
